<template>
  <div class="w-full width-50-set stpcreat-cardlbl-parent">
    <!-- <div class="onboard-title cust-sera-btn">
      <div>
        <div class="cust-headerban mb-4">
          <span class="cust-fontsetban sm-font-16px">
            Looking for a service?
          </span>

          <p class="cust-ban-childrtext lg:px-0 md:px-0 px-4 sm-font-12px">
            Find a service near to your location
          </p>
        </div>
      </div>
      <div class="flex w-full items-center lg:my-5 lg:px-0 md:px-0 px-4">
        <b-form-input
          id="input-default"
          label-size="large"
          v-model="search"
          class="w-3/4 h-54px sm-h-38px"
          placeholder="Search Location"
        ></b-form-input>

        <div class="search w-1/4">
          <base-button
            outline
            type="primary"
            class="padding-search-btn search-clr-btn ml-2 sm-padding"
            v-modal="searchQuery"
            >Search</base-button
          >
        </div>
      </div>
    </div> -->
    <!-- <div class> -->
    <!-- <div class="footer-bannersec lg:mt-0 md:mt-0 mt-4"> -->
    <!-- <span class="cust-ban-cities lg:pl-0 md:pl-2 pl-4 my-6">
          List of Location as per the Service Providers
        </span> -->
    <!-- <span class="font-semibold fsize18px lg:pl-0 md:pl-2 my-6">
        Browse Location
      </span> -->
    <!-- 
        <ul class="flex flex-wrap pt-3">
          <li
            v-for="(turflocation, index) in turflocations"
            :key="'turflocation' - index"
            class="cuts-footerban-tit"
            @click="searchThisLocation(turflocation)"
          >
            TURF in {{ turflocation }} <span class="pl-2"> |</span>
          </li>
        </ul> -->

    <!-- <div class="flex flex-wrap mt-2 lg:pl-2 md:pl-2">
          <div
            class="lg:w-1/3 md:w-1/3 w-1/2"
            v-for="(turflocation, index) in turflocations"
            :key="'turflocation-' + index"
            @click="searchThisLocation(turflocation)"
          >
            <div class="turflist-name py-1 turflist-hover">
              <span class="fsize14 cursor-pointer">
                -&nbsp; {{ turflocation }}
              </span>
            </div>
          </div>
        </div> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- <br /> -->

    <div class>
      <!-- <hr /> -->
      <div class="footer-bannersec lg:mt-4 md:mt-0 mt-4">
        <!-- <span class="cust-ban-cities lg:pl-0 md:pl-2 pl-4 my-6">
          List of Services
        </span> -->
        <span class="font-semibold fsize18px lg:pl-0 md:pl-2 my-6">
          Explore Services
        </span>
        <!-- 
        <ul class="flex flex-wrap pt-3">
          <li
            v-for="(turflocation, index) in turflocations"
            :key="'turflocation' - index"
            class="cuts-footerban-tit"
            @click="searchThisLocation(turflocation)"
          >
            TURF in {{ turflocation }} <span class="pl-2"> |</span>
          </li>
        </ul> -->

        <!-- <div class="flex flex-wrap mt-2 lg:pl-2 md:pl-2 pl-4">
          <div
            class="lg:w-1/3 md:w-1/3 w-1/2"
            v-for="(turflocation, index) in turflocations"
            :key="'turflocation-' + index"
            @click="searchThisLocation(turflocation)"
          >
            <div class="turflist-name turflist-hover">
              <span class="fsize16 turflist-span">
                {{ turflocation }}
              </span>
            </div>
          </div>
        </div> -->
        <div class="grid grid-cols-2 gap-2 mt-2 lg:pl-2 md:pl-2">
          <div
            class=""
            v-for="(service, index) in get_AllService.result"
            :key="'service-' + index"
            @click="handleRedirect(service)"
          >
            <!-- @click="searchThisLocation(service)" -->
            <div class="turflist-name turflist-hover">
              <span class="fsize14 py-2 cursor-pointer">
                -&nbsp;{{ service.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="flex gap-5">
          <el-select placeholder="Service Provider" class="w-full">
            <el-option disabled="true">Select Channel...</el-option>
            <el-option>Private Channel</el-option>
            <el-option>Public Channel</el-option>
          </el-select>
          <el-select placeholder="Location" class="">
            <el-option disabled="true">Select Channel...</el-option>
            <el-option>Private Channel</el-option>
            <el-option>Public Channel</el-option>
          </el-select>
        </div>
        <div class="lg:pt-5 md:pt-5 pt-4">
          <base-button
            outline
            type="primary"
            class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
            @click="searchThisLocation(turflocation)"
            >Search</base-button
          >
        </div> -->
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
export default {
  data() {
    return {
      search: "",
      locateme: "",
      locations: [
        "West Mumbai",
        "South Mumbai",
        "East Mumbai",
        "North Mumbai",
        "Chandivali",
      ],
      turflocations: [],
      services: [
        // "Caregiver Coaching",
        // "Family Counseling",
        // "Caregiver counseling and therapy",
        // "Care Assistance",
        // "Will an inheritance",
      ],
      searchQuery: "",
    };
  },
  watch: {
    locateme(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$store.commit("respitecare/SET_SEARCH_VALUE", newValue);
      }
    },
    search() {
      this.handleSearch();
    },
  },
  // computed: {
  // ...mapState("services", { get_AllService: "get_AllService" }),
  // validate() {
  //   return !this.locateme;
  // },
  // },
  methods: {
    async handleRedirect(item) {
      let loader = this.$loading();
      if (item.isURL) {
        window.open(`${item.link}?service=${item.title}`, "_blank");
      } else {
        this.$router.push(`service-overview?service=${item.title}`);
      }
      loader.close();
    },
    async nextPage() {
      if (!this.locateme) return;
      let loader = this.$loading();
      this.$store.commit("respitecare/SET_Location", this.locateme);
      await this.$store.dispatch("respitecare/get_volunteerbylocation", {
        location: this.locateme.toLowerCase(),
      });

      loader.close();
      this.$router
        .push({ name: "map-inside", query: { location: this.locateme } })
        .catch(() => {});
    },
    searchThisLocation(location) {
      this.locateme = location;
      this.nextPage();
    },
    handleSearch() {
      var searchExpr = new RegExp(this.search.toLowerCase(), "gi");

      // this.turflocations = this.locations.filter((location) =>
      //   searchExpr.test(location.toLowerCase())
      // );
      this.turflocations = [];
      this.locations.forEach((location) => {
        if (searchExpr.test(location.toLowerCase())) {
          searchExpr.test(location);
          this.turflocations.push(location);
          // console.log(location);
        }
      });
      // console.log(this.turflocations);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async init() {
      await this.$store.dispatch("respitecare/get_all_location_name");
      this.locations = this.get_all_location_name;
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
    ...mapState("respitecare", {
      get_all_location_name: "get_all_location_name",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
    validate() {
      return !this.locateme;
    },
    filteredData() {
      return this.location.filter((item) => {
        item.toLowercase().includes(this.searchQuery.toLowerCase());
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("services/get_all");
    this.services = this.get_AllService.result;
    // console.log(this.services);
    // console.log(this.services.this.get_AllService);
    await this.init();
    this.turflocations = this.locations;
  },
};
</script>
<style>
.vs-input--input {
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}
.cust-plac-center > div > .input-span-placeholder {
  text-align: start !important;
}
.vs-input--placeholder.large {
  padding: 1rem;
}
.border-clr {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.vs-input--input.large {
  padding: 1rem;
  font-size: 1.2rem;
}
.h-54px {
  height: 54px;
}
.padding-search-btn {
  padding: 1rem 2.5rem;
}
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.cust-fontsetban {
  font-size: 30px;
  font-weight: 600 !important;
}
.cust-ban-cities {
  font-size: 15px;
  color: #a9abb2;
  margin: 30px 0 10px;
  letter-spacing: -0.2px;
  text-transform: uppercase;
  font-weight: 600;
}
.turflist-span {
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}
.turflist-hover:hover {
  color: #60d394;
}
@media (max-width: 640px) {
  .sm-font-20px {
    font-size: 20px;
  }
  .sm-font-16px {
    font-size: 16px;
  }
  .sm-font-12px {
    font-size: 12px;
  }

  .sm-h-38px {
    height: 38px;
  }
  .sm-padding {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .cust-ban-cities {
    font-size: 14px !important;
  }
  .turflist-span {
    font-size: 12px !important;
  }
}
.fsize {
  font-size: 16px;
}
</style>
